// Without a fingerprint, Sentry groups by stack trace, which for a failed request is always the same frames in http.ts.

const HTTP_ERROR = 'http-error';
const NETWORK_ERROR = 'network-error';

/** `endpoint` is the registry key (`POST /assemblies/bulk`): method included, path templated, no normalising needed. */
export function httpErrorFingerprint({ endpoint, status }: { endpoint: string; status: number }): string[] {
    return [HTTP_ERROR, endpoint, statusFingerprintPart(status)];
}

/** A network error never reached us, whatever the endpoint; naming it keeps one issue when `http.ts` is refactored. */
export function networkErrorFingerprint(): string[] {
    return [NETWORK_ERROR];
}

/** One outage answers 500, 502, 503 and 504 by turns; 4xx stays exact, as a 401 and a 404 have different owners. */
function statusFingerprintPart(status: number): string {
    return status >= 500 && status < 600 ? '5xx' : String(status);
}
